(function() {
  const userLang = navigator.language || navigator.userLanguage;
  const path = window.location.pathname;
  const referrer = document.referrer;

  // ✅ Cas 1 : si l'utilisateur vient juste de /fr ou /en vers / → on en déduit un clic sur "Italiano"
  if (
    (path === '/' || path === '/index.html') &&
    (referrer.includes('/fr') || referrer.includes('/en'))
  ) {
    localStorage.setItem('lang_selected', 'manual');
    return;
  }

  // ✅ Cas 2 : ne pas rediriger si sur /fr ou /en
  if (path.startsWith('/fr') || path.startsWith('/en')) return;

  // ✅ Cas 3 : ne pas rediriger si le choix est déjà mémorisé
  if (localStorage.getItem('lang_selected') === 'manual') return;

  // ✅ Cas 4 : redirection selon la langue du navigateur
  if (userLang.startsWith('fr')) {
    window.location.replace('/fr' + path);
  } else if (!userLang.startsWith('it')) {
    window.location.replace('/en' + path);
  }
})();


